import { NgModule } from '@angular/core';
import { AirBookingResourceService } from './air-booking-resource.service';
import { ResourceModule } from "../../resource/resource.module";
import {
    AirBookingRequesterHelperService
} from "libraries/service/resources/air-booking/air-booking-requester-helper.service";


@NgModule({
    imports: [
        ResourceModule
    ],
    providers: [
        AirBookingResourceService,
        AirBookingRequesterHelperService,
    ],
})
export class AirBookingResourceModule {
}
